import React from 'react';
import { useTranslation } from 'react-i18next';

function InternalIdentifier({ vehicle }) {
  const { t } = useTranslation(['booking', 'common', 'search']);

  return (
    <div className="section flex-row">
      <div>
        <div className="title">{t('booking:internal_identifier')}</div>
        <div className="section-content">{vehicle.internal_identifier}</div>
      </div>
      <div>
        <div className="title">{t('booking:plate-number')}</div>
        <div className="section-content">{vehicle.license_plate}</div>
      </div>
    </div>
  );
}

export default InternalIdentifier;
